import { TypedDocumentNode } from '@graphql-typed-document-node/core'
import { DocumentNode } from 'graphql'
import { Component, ComputedRef, Raw, Ref } from 'vue'
import { Column } from '@/vue-prop-types/DataTable/types'
import { DataDescriber } from '@/utils/apiDataExports'
import { SortOption } from '@/components/BaseDataTable/composables/dataTableSort'

export enum ColumnFragmentListSupport {
  NONE,
  SINGLE,
  LIST,
}

export interface ListSupportConfig {
  supportType: ColumnFragmentListSupport.SINGLE | ColumnFragmentListSupport.LIST
  listFieldName: string
}

export interface ListSupportExpand extends ListSupportConfig {
  supportType: ColumnFragmentListSupport.LIST
  keyOf: (item: any) => string
  titleOf: (item: any) => string
  useAvailableItems: () => {
    items: ComputedRef<{ key: string; title: string }[]>
    loading: Ref<boolean>
  }
}

export interface GraphqlColumnMap {
  fragment?: TypedDocumentNode
  frag?: DocumentNode
  component: Raw<Component<{ row?: any }>>
  columnDef: Column
  dataDescriber: DataDescriber<any>[]
  sort?: SortOption[]
  path?: string
  listSupport?: ListSupportConfig | ListSupportExpand
}

export type ColumnMaps = Record<string, GraphqlColumnMap>
